@if (!isLoading) {
  <div class="c__header">
    <sd-icon
      [brand]="brand"
      [name]="icon ? icon : 'icon-brand-xs-circle'"
      [class]="icon ? 'has-custom-icon' : ''"
      [size]="IconSize.small"
    />
    <sd-title [titleLevel]="titleLevel" customClass="brand--h4 is-text-brand">
      {{title}}
    </sd-title>
  </div>
  <sd-html innerClass="c__content is-wysiwyg" [html]="content" tag="div" />
}

@if (isLoading) {
  <sd-skeleton
    [appearance]="SkeletonAppearanceEnum.heading"
    [sizeChangeMobile]="false"
    [count]="2"
  />
}
